<template>
    <div class="border-b border-violet-200 bg-gradient-to-r from-violet-50 to-violet-100 px-6 py-2" data-testid="role-play-banner">
        <div class="mx-auto flex max-w-3xl items-center justify-between gap-4">
            <div class="flex items-center gap-2 text-xs">
                <span class="flex h-2 w-2 animate-pulse rounded-full bg-violet-700"></span>
                <span class="font-medium text-violet-900">In role-play —</span>
                <span class="text-violet-800">
                    Nadia is in character as <strong>{{ active.persona_name }}</strong
                    ><span v-if="active.persona_relationship">, your {{ active.persona_relationship }}</span
                    >.
                </span>
            </div>
            <button
                type="button"
                class="rounded border border-violet-300 bg-white px-2 py-1 text-[11px] font-medium text-violet-700 hover:bg-violet-50 disabled:opacity-50"
                data-testid="role-play-banner-end"
                :disabled="ending"
                @click="onEnd">
                {{ ending ? "Ending…" : "End role-play" }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import type { RolePlayStartedData } from "./types";

defineProps<{ active: RolePlayStartedData }>();

const emit = defineEmits<{
    (e: "submit", payload: { message: string }): void;
}>();

const ending = ref(false);

const onEnd = () => {
    if (ending.value) {
        return;
    }
    ending.value = true;
    // Same shape as the setup card: synthesize a user message that will
    // cause the agent to call `end_role_play`. The agent skill body lists
    // the wrap-up triggers so this phrasing maps cleanly.
    emit("submit", { message: "Let's wrap up the role-play. Please end it and give me the summary." });
};
</script>
